import {useEffect, useState} from "react";
import '../Styles/Quiz.css';

const Exam = ({onFinish, exam, participantId}) => {
    const [questions, setQuestions] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [score, setScore] = useState(0);
    const [showResults, setShowResults] = useState(false);
    const [loading, setLoading] = useState(true);
    const [currentQuestion, setCurrentQuestion] = useState([]);


    useEffect(() => {
        fetchQuestions().then(r => console.log("exam questions fetched"));
    }, []);

    const fetchQuestions = async () => {
        try {
            const response = await fetch(`http://13.61.177.7:8080/exams/${exam.id}/questions`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to load questions: ${response.status}`);
            }

            const data = await response.json();
            setQuestions(data);
            setLoading(false);
            setCurrentQuestion(data[0]);
            console.log("questions: " + data);


        } catch (error) {
            console.error("Error fetching questions:", error);
            setLoading(false);
        }
    };

    const handleAnswerSelection = (answer) => {
        setSelectedAnswer(answer);
        console.log("selected answeer: " + answer);
    };

    const handleNextQuestion = async () => {
        if (selectedAnswer === questions[currentQuestionIndex].correctAnswer) {
            setScore(score + 1);
        }

        const payload = {
            exam: {
                id: exam.id
            },
            participant: {
                id: participantId
            },
            question: {
                id: questions[currentQuestionIndex].id
            },
            selectedOption: selectedAnswer,
            answerTime: new Date().toISOString(),
            correct: selectedAnswer === questions[currentQuestionIndex].correctAnswer
        };

        console.log("Sending payload:", JSON.stringify(payload));

        try {
            const response = await fetch("http://13.61.177.7:8080/exam-answers", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`Failed to save answer: ${response.statusText}`);
            }

            console.log("Answer saved successfully!");

            // Sonraki soruya geç
            if (currentQuestionIndex + 1 < questions.length) {
                setCurrentQuestionIndex(prev=> prev +1 );
                setSelectedAnswer(null);
                setCurrentQuestion(questions[currentQuestionIndex + 1]);
            } else {
                onFinish(score, exam.id);
                setShowResults(true);
            }
        } catch (error) {
            console.error("Error saving answer:", error);
            alert("Cevap kaydedilirken bir hata oluştu!");
        }
    };

    return (
        <div>
            <h2 align="center">{exam.examName}</h2>
            <div className="quiz-container">
                {showResults ? (
                    <div>
                        <h2>Sınav Tamamlandı!</h2>
                        <p>Skorun: {score} / {questions.length}</p>
                    </div>
                ) : (
                    <div key={currentQuestionIndex}>

                        <h2>{currentQuestion?.question}</h2>
                        {currentQuestion && typeof currentQuestion === "object" && (

                        <ul >
                            {['op_1', 'op_2', 'op_3', 'op_4', 'op_5']
                                .filter(option => currentQuestion[option])
                                .map((option, index) => (
                                    <li key={index}>
                                        <button
                                            onClick={() => handleAnswerSelection(currentQuestion[option])}
                                            style={{
                                                backgroundColor: selectedAnswer === currentQuestion[option]
                                                    ? "#add8e6"
                                                    : "white"
                                            }}
                                        >
                                            {currentQuestion[option]}
                                        </button>
                                    </li>
                                ))}
                        </ul>
                            )}
                        <button
                            onClick={handleNextQuestion}
                            disabled={!selectedAnswer}
                        >
                            {currentQuestionIndex + 1 === questions.length ? "Sınavı Bitir" : "Sonraki Soru"}
                        </button>
                    </div>
                )}
            </div>

        </div>
    );
};
export default Exam;